<template>
  <vs-card>
    <div class="vx-row flex">
      <div class="vx-col vx-col sm:w-1/4 w-full">
        <label for="" class="vs-select--label">Tipo de Proposta</label>
        <v-select
          :options="tiposProposta"
          name="Tipo de Proposta"
          id="tipoProposta"
          v-model="form.tipoProposta"
          @input="emitChangedForm('tipoProposta', form.tipoProposta)"
          label="Tipo de proposta"
          class="select-large w-full"
          :reduce="(item) => item"
          v-validate="{ required: true }"
          :state="validateState('Tipo de Proposta')"
          :danger="validateClass('Tipo de Proposta')"
        ></v-select>
      </div>

      <div class="vx-col sm:w-1/4 w-full">
        <label for="" class="vs-select--label">Origem</label>
        <v-select
          :options="origens"
          name="Origem"
          label="label"
          id="origem"
          v-model="form.origem"
          @input="emitChangedForm('origem', form.origem)"
          class="select-large w-full"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
          :state="validateState('Origem')"
          :danger="validateClass('Origem')"
        ></v-select>
      </div>

      <div v-if="!verificaEmpresa()" class="vx-col sm:w-1/4 w-full">
        <label for="" class="vs-select--label">Status</label>
        <v-select
          :options="statusPropostas"
          name="Status"
          label="label"
          id="idStatus"
          v-model="form.idStatus"
          @input="emitChangedForm('idStatus', form.idStatus)"
          class="select-large w-full"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
          :state="validateState('Status')"
          :danger="validateClass('Status')"
        ></v-select>
      </div>

      <div v-if="apolices.length" class="vx-col sm:w-1/4 w-full">
        <label for="" class="vs-select--label">Apólices</label>
        <v-select
          :options="apolices"
          name="apolices"
          label="label"
          id="idApoliceRegional"
          v-model="form.idApolice"
          @input="emitChangedForm('idApolice', form.idApolice)"
          class="select-large w-full"
          :reduce="(item) => item.idApoliceRegional"
          v-validate="{ required: false }"
          :state="validateState('apolices')"
          :danger="validateClass('apolices')"
          :disabled="verificaPodeEditarApolice()"
        ></v-select>
      </div>

      <div class="vx-col sm:w-1/4 w-full">
        <label for="" class="vs-select--label">Regional</label>
        <v-select
          :options="regionais"
          name="Regional"
          label="label"
          id="Regional"
          v-model="form.idRegional"
          @input="emitChangedForm('idRegional', form.idRegional)"
          class="select-large w-full"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
          :state="validateState('Regional')"
          :danger="validateClass('Regional')"
        ></v-select>
      </div>

      <div class="vx-col sm:w-1/4 w-full">
        <label for="" class="vs-select--label">Consultor</label>
        <v-select
          :options="consultores"
          name="Consultor"
          label="label"
          id="idUsuario"
          v-model="form.idUsuario"
          @input="emitChangedForm('idUsuario', form.idUsuario)"
          class="select-large w-full"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
          :state="validateState('Consultor')"
          :danger="validateClass('Consultor')"
        ></v-select>
      </div>

      <div class="vx-col sm:w-1/4 w-full">
        <label for="" class="vs-select--label">Divisão</label>
        <v-select
          :options="divisoes"
          name="Divisão"
          label="label"
          id="idDivisao"
          v-model="form.idDivisao"
          @input="emitChangedForm('idDivisao', form.idDivisao)"
          class="select-large w-full"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
          :state="validateState('Divisão')"
          :danger="validateClass('Divisão')"
        ></v-select>
      </div>

      <div
        class="vx-col sm:w-1/4 w-full"
        v-if="$can('Editar Responsável Vistoria', 'Vistorias')"
      >
        <label for="" class="vs-select--label">Responsável pela Vistoria</label>
        <v-select
          :options="colaboradoresCadastro"
          name="Responsável pela Vistoria"
          label="label"
          id="idUsuarioResponsavelVistoria"
          v-model="form.idUsuarioResponsavelVistoria"
          @input="
            emitChangedForm(
              'idUsuarioResponsavelVistoria',
              form.idUsuarioResponsavelVistoria,
            )
          "
          class="select-large w-full"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
          :state="validateState('Responsável pela Vistoria')"
          :danger="validateClass('Responsável pela Vistoria')"
        ></v-select>
      </div>

      <div class="vx-col sm:w-1/4 w-full">
        <label for="" class="vs-select--label">Origem do Lead</label>
        <v-select
          :options="listLeads"
          name="Origem do Lead"
          label="origem"
          id="idOrigemLeads"
          v-model="form.origemLead"
          @input="emitChangedForm('origemLead', form.origemLead)"
          class="select-large w-full"
          :reduce="(item) => item.idOrigemLeads"
          v-validate="{ required: true }"
          :state="validateState('Origem do Lead')"
          :danger="validateClass('Origem do Lead')"
        ></v-select>
      </div>
    </div>

    <div v-if="!verificaEmpresa()" class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Veículo Zero</label>
        <vs-switch
          color="success"
          v-model.number="form.isZero"
          id="isZero"
          @change="emitChangedForm('isZero', form.isZero)"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <div v-if="form.isZero == true" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Nota Fiscal"
          v-model="form.nf"
          name="Nota Fiscal"
          id="nf"
          @change="emitChangedForm('nf', form.nf)"
          v-validate="{ required: true }"
          :state="validateState('Nota Fiscal')"
          :danger="validateClass('Nota Fiscal')"
        />
      </div>

      <div v-if="form.isZero == true" class="vx-col sm:w-1/4 w-full mb-6">
        <vs-input
          class="w-full"
          label="Data da NF"
          v-model="form.dataNf"
          v-mask="'##/##/####'"
          name="Data de saída da NF"
          id="dataSaidaNF"
          @change="
            emitChangedForm('dataNf', form.dataNf),
              emitChangedForm('dataNf', form.dataNf, 'dadosVeiculo')
          "
          v-validate="'date_format:dd/MM/yyyy'"
          :state="validateState('Data de saída da NF')"
          :danger="validateClass('Data de saída da NF')"
        />
      </div>

      <div v-if="form.isZero == true" class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Valor Nota</label>
        <money
          class="vs-inputx vs-input--input normal"
          name="Valor Nota"
          v-model="form.valorNf"
          id="valorNf"
          @blur.native="emitChangedForm('valorNf', form.valorNf)"
          v-validate="{ required: true }"
          :state="validateState('Valor Nota')"
          :danger="validateClass('Valor Nota')"
          v-bind="money"
        ></money>
      </div>

      <div class="vx-col sm:w-2/4 w-full mb-2">
        <label for class="vs-input--label"
          >Opcionais disponíveis para edição do beneficiário.</label
        >
        <vs-switch
          color="success"
          v-model="form.permiteInvoiceSelfService"
          id="permiteInvoiceSelfService"
          @change="
            emitChangedForm(
              'permiteInvoiceSelfService',
              form.permiteInvoiceSelfService,
            )
          "
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
    </div>

    <div v-else class="vx-row">
      <div class="vx-col sm:w-2/4 w-full mb-6 mt-6">
        <label for class="vs-input--label"
          >Opcionais disponíveis para edição do beneficiário.</label
        >
        <vs-switch
          color="success"
          v-model="form.permiteInvoiceSelfService"
          id="permiteInvoiceSelfService"
          @change="
            emitChangedForm(
              'permiteInvoiceSelfService',
              form.permiteInvoiceSelfService,
            )
          "
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
    </div>

    <div class="vx-row">
      <div v-if="form.idStatus == 2" class="vx-col w-full mb-2">
        <label for class="vs-input--label">Motivo da Recusa</label>
        <vs-input
          size="large"
          class="w-full"
          name="Motivo"
          id="restricaoDescricao"
          v-model="form.restricaoDescricao"
          @change="
            emitChangedForm('restricaoDescricao', form.restricaoDescricao)
          "
          appendToBody
          v-validate="{ required: true }"
          :state="validateState('Motivo')"
          :danger="validateClass('Motivo')"
          val-icon-danger="clear"
          danger-text="Preencha este Campo"
        />
      </div>

      <div v-if="fotos.length > 0" class="vx-col w-full mb-2">
        <label for="" class="vs-select--label">Fotos a serem Resetadas</label>
        <v-select
          :options="fotos"
          name="Fotos"
          label="label"
          id="fotosResetadas"
          v-model="form.fotosResetadas"
          @input="
            selecionaRestricoes(),
              emitChangedForm('fotosResetadas', form.fotosResetadas)
          "
          class="select-large w-full"
          :reduce="(item) => item.id"
          :state="validateState('Fotos')"
          :danger="validateClass('Fotos')"
          multiple
        ></v-select>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <vs-textarea
          label="Observações"
          v-model="form.observacao"
          id="observacao"
          @change="emitChangedForm('observacao', form.observacao)"
        />
      </div>
    </div>

    <div v-if="permitirRestricoes" class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <label for="" class="vs-select--label">Restrições</label>
        <v-select
          :options="restricoes"
          name="Restrições"
          label="descricao"
          id="restricoesSelecionadas"
          v-model="form.restricoesSelecionadas"
          @input="
            emitChangedForm(
              'restricoesSelecionadas',
              form.restricoesSelecionadas,
            )
          "
          class="select-large w-full"
          :reduce="(item) => item.idRestricao"
          v-validate="{ required: true }"
          :state="validateState('Restrições')"
          :danger="validateClass('Restrições')"
          multiple
        ></v-select>
      </div>
    </div>
  </vs-card>
</template>

<script>
import service from './../../services';
import functions from './../../utils/functions';
import locale from './../../locale';
import { Money } from 'v-money';
import moment from 'moment';
import vSelect from 'vue-select';

export default {
  components: { Money, 'v-select': vSelect },
  props: [
    'dadosProposta',
    'formulario',
    'regionais',
    'divisoes',
    'colaboradoresCadastro',
    'status',
    'consultores',
    'fotos',
    'dadosUsuario',
  ],
  watch: {
    async dadosProposta() {
      await this.buscaApolicesRegional();

      this.preencheForm();
    },
    status() {
      this.statusPropostas = this.status;
    },
    async dadosUsuario() {
      await this.verificaUsarioPodeAlterarStatus();
    },
  },
  data() {
    return {
      statusPropostas: [],
      naoPermiteUsuarioAlterarStatus: true,
      idEmpresa: null,
      permitirRestricoes: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      tiposProposta: [
        'Adesão',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      origens: [
        { label: 'Selecione', id: null },
        { label: 'Network', id: 'Network' },
        { label: 'Indicação', id: 'Indicação' },
        { label: 'Site', id: 'Site' },
      ],
      listLeads: [],
      restricoes: [],
      restricoesSelecionadas: [],
      isCarroZero: false,
      form: {
        tipoProposta: null,
        origem: null,
        idStatus: null,
        idRegional: null,
        idUsuario: null,
        idDivisao: null,
        idUsuarioResponsavelVistoria: null,
        podeAlterarResponsavelVistoria: false,
        isZero: 0,
        nf: null,
        valorNf: null,
        dataNf: null,
        observacao: null,
        restricaoDescricao: null,
        fotosResetadas: [],
        restricoesSelecionadas: null,
        codigoExterno: null,
        permiteInvoiceSelfService: null,
        origemLead: null,
        idApolice: null,
      },
      apolices: [],
      idRegional: null,
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    selecionaRestricoes() {
      this.form.restricoesSelecionadas = [];
      this.restricoesSelecionadas.forEach((element) => {
        this.form.restricoesSelecionadas.push(element);
      });
    },
    buscaRestricoes() {
      return new Promise(async () => {
        service
          .getAll('Restricoes', {}, `list/idEmpresa=${this.form.idEmpresa}`)
          .then((res) => {
            var aux = res.data.filter((x) => x.deletedAt == null);
            this.restricoes = aux;
            this.restricoes.push({
              idRestricao: null,
              descricao: 'Nenhuma Restrição',
            });
          });
      });
    },
    preencheForm() {
      if (this.formulario.dadosGerais.idProposta) {
        this.form = this.formulario.dadosGerais;
        this.emitLoadedForm();

        return;
      }

      if (this.dadosProposta.idProposta) {
        if (this.dadosProposta.dadosVendedor) {
          this.form.idUsuario = this.dadosProposta.dadosVendedor.idUsuario;
        }
        this.form.idProposta = this.dadosProposta.idProposta;
        this.form.idRegional = this.dadosProposta.idRegional;
        this.form.idDivisao = this.dadosProposta.idDivisao;
        this.form.tipoProposta = this.dadosProposta.tipoProposta;
        this.form.idUsuarioResponsavelVistoria =
          this.dadosProposta.idResponsavel;
        this.form.origem = this.dadosProposta.origem;
        this.form.idStatus = this.dadosProposta.idStatus;
        this.form.isZero = this.dadosProposta.isZero ? 1 : 0;
        this.form.nf = this.dadosProposta.nf;
        this.form.valorNf = this.dadosProposta.valorNf;
        this.form.codigoExterno = this.dadosProposta.codigoExterno;
        this.form.permiteInvoiceSelfService =
          this.dadosProposta.permiteInvoiceSelfService;
        this.form.dataNf =
          this.dadosProposta.dataNf == null
            ? null
            : this.dadosProposta.dataNf.replace('Z', '');
        this.form.observacao = this.dadosProposta.observacao;
        this.form.restricaoDescricao = this.dadosProposta.restricaoDescricao;

        this.dadosProposta.restricoes.forEach((element) => {
          this.restricoesSelecionadas.push(element.idRestricao);
        });

        const lead = this.listLeads.find(
          (item) => item.origem == this.dadosProposta.nomeOrigemLead,
        );
        this.form.origemLead = lead ? lead.idOrigemLeads : null;
        this.form.idApolice = this.dadosProposta.idApolice;

        this.selecionaRestricoes();
      }

      this.emitLoadedForm();
    },
    emitChangedForm(id, value) {
      this.$emit('changed', { formulario: 'dadosGerais', id, value });
    },
    emitLoadedForm() {
      this.$emit('loaded', { formulario: 'dadosGerais', ...this.form });
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    formataDataStr(data) {
      var dia = data.split('/')[0];
      var mes = data.split('/')[1];
      var ano = data.split('/')[2];

      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2);
    },
    buscaDadosEmpresa() {
      return new Promise((resolve) => {
        service
          .getAll('g', {}, 'empresas/list/idEmpresa/' + this.idEmpresa)
          .then((res) => {
            this.permitirRestricoes = res.data[0].permitirRestricoes;
            resolve();
          })
          .catch((e) => {
            console.log(513, e);
          });
      });
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
    permitirUsuarioConsultorAlterarStatus(dadosUsuario) {
      const { consultor, superUser } = dadosUsuario;
      const podeAlterarStatusProposta = this.$can(
        'Permite consultor alterar status',
        'Cotações',
      );

      const statusPropostaPermiteAlteracao =
        this.form.idStatus == '5' ? true : false;

      if (
        consultor &&
        podeAlterarStatusProposta &&
        statusPropostaPermiteAlteracao &&
        !superUser
      ) {
        const _statusProposta = this.status.filter(
          (status) => status.id == 5 || status.id == 3,
        );

        this.statusPropostas = _statusProposta;
        this.naoPermiteUsuarioAlterarStatus = false;
        return;
      }

      if (
        consultor &&
        (!podeAlterarStatusProposta || !statusPropostaPermiteAlteracao) &&
        !superUser
      ) {
        this.naoPermiteUsuarioAlterarStatus = true;
        return;
      }

      this.naoPermiteUsuarioAlterarStatus = false;
    },
    async verificaUsarioPodeAlterarStatus() {
      new Promise(async (resolve) => {
        const isEmpresaBemProtege = this.verificaEmpresa();
        if (isEmpresaBemProtege) {
          await this.permitirUsuarioConsultorAlterarStatus(this.dadosUsuario);
        }
        resolve();
      });
    },
    async buscaOrigemLeads() {
      try {
        this.$vs.loading();
        const result = await service.getAll('Leads', {}, 'buscar-origem-leads');
        this.listLeads = result.data;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao busca os dados da origem dos leads.',
          color: 'danger',
          timer: 5000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaApolicesRegional() {
      try {
        this.$vs.loading();

        const apolices = await service.getAll(
          'Regional',
          {},
          'apolicesRegional/' + this.dadosProposta.idRegional,
        );

        apolices.data.forEach((apolice) => {
          apolice.label = `${apolice.nomeContrato} - ${apolice.numeroApolice}`;
        });

        this.apolices = apolices.data;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao busca apolices da regional',
          color: 'danger',
          timer: 5000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    verificaPodeEditarApolice() {
      return this.$can('Não Editar número da apólice', 'Cotações');
    },
  },
  async created() {
    this.idEmpresa = localStorage.getItem('idEmpresa');
  },
  async mounted() {
    this.buscaRestricoes();
    this.buscaDadosEmpresa();
    this.buscaOrigemLeads();
    this.$validator.localize('ptBr', locale);
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
